import { HotelDetailContainer } from "../../../containers";
function HotelDetail() {
  return <HotelDetailContainer />;
}
export default HotelDetail;
